import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Divider from "@material-ui/core/Divider";
import FacebookIcon from "@material-ui/icons/Facebook";
import Grid from "@material-ui/core/Grid";
import InstagramIcon from "@material-ui/icons/Instagram";
import Link from "@material-ui/core/Link";
import LinkedInIcon from "@material-ui/icons/LinkedIn";
import TwitterIcon from "@material-ui/icons/Twitter";
import Typography from "@material-ui/core/Typography";
import YouTubeIcon from "@material-ui/icons/YouTube";

const useStyles = makeStyles((theme) => ({
  "@global": {
    ul: {
      margin: 0,
      padding: 0,
      listStyle: "none",
    },
  },
  footerContainer: {
    backgroundColor: "#F5F9FF",
  },
  footer: {
    paddingTop: theme.spacing(3),
    [theme.breakpoints.up("sm")]: {
      paddingTop: theme.spacing(6),
    },
  },
  footerColumn: {
    [theme.breakpoints.up("xs")]: {
      textAlign: "center",
    },
    [theme.breakpoints.up("sm")]: {
      textAlign: "center",
    },
    [theme.breakpoints.up("md")]: {
      textAlign: "left",
    },
  },
  footer__logo: {
    height: 80,
    margin: "24px 14px",
  },
  footerHeader: {
    color: "#232938",
    fontSize: "16px",
    fontWeight: 500,
    letterSpacing: "0.5px",
  },
  footerLink: {
    color: "#5B627D",
    fontSize: "14px",
    lineHeight: "25px",
    transitionProperty: "all",
    transitionDuration: ".4s",
    transitionTimingFunction: "cubic-bezier(0.16, 1, 0.29, 0.99)",

    "&:hover": {
      color: "#232938",
      textDecoration: "none",
    },
  },
  socialLink: {
    padding: "0 8px",
  },
  privacyBorder: {
    borderLeft: "1px solid #C8CEE3",
    padding: "0 8px",
  },
}));

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {"Copyright © "}
      {new Date().getFullYear()}
      &nbsp;Buildscale, Inc d/b/a Vidyard
    </Typography>
  );
}

function Footer() {
  const classes = useStyles();
  return (
    <div className={classes.footerContainer}>
      <Container maxWidth="lg" component="footer" className={classes.footer}>
        <Grid container spacing={4} justify="space-evenly">
          <Link
            href="https://vidyard.com"
            target="_blank"
            className={classes.footer__logo}
          >
            <img
              height="80"
              src="https://www.vidyard.com/wp-content/themes/vidyard-website/img/brand/vidyard-icon-full.svg"
              alt="Vidyard Logo"
            />
          </Link>
          <Grid item xs={12} sm={12} md={2} className={classes.footerColumn}>
            <Typography
              variant="h6"
              color="textPrimary"
              className={classes.footerHeader}
              gutterBottom
            >
              Company
            </Typography>
            <ul>
              <li>
                <Link
                  variant="subtitle1"
                  color="textSecondary"
                  className={classes.footerLink}
                  href="https://www.vidyard.com/about/"
                  target="_blank"
                >
                  About Us
                </Link>
              </li>
              <li>
                <Link
                  variant="subtitle1"
                  color="textSecondary"
                  className={classes.footerLink}
                  href="https://www.vidyard.com/history/"
                  target="_blank"
                >
                  History
                </Link>
              </li>
              <li>
                <Link
                  variant="subtitle1"
                  color="textSecondary"
                  className={classes.footerLink}
                  href="https://www.vidyard.com/careers/"
                  target="_blank"
                >
                  Careers
                </Link>
              </li>
              <li>
                <Link
                  variant="subtitle1"
                  color="textSecondary"
                  className={classes.footerLink}
                  href="https://www.vidyard.com/press/"
                  target="_blank"
                >
                  Press
                </Link>
              </li>
              <li>
                <Link
                  variant="subtitle1"
                  color="textSecondary"
                  className={classes.footerLink}
                  href="https://www.vidyard.com/media-kit/"
                  target="_blank"
                >
                  Media Kit
                </Link>
              </li>
              <li>
                <Link
                  variant="subtitle1"
                  color="textSecondary"
                  className={classes.footerLink}
                  href="https://www.vidyard.com/contact/"
                  target="_blank"
                >
                  Contact Us
                </Link>
              </li>
            </ul>
          </Grid>
          <Grid item xs={12} sm={12} md={2} className={classes.footerColumn}>
            <Typography
              variant="h6"
              color="textPrimary"
              className={classes.footerHeader}
              gutterBottom
            >
              Product
            </Typography>
            <ul>
              <li>
                <Link
                  variant="subtitle1"
                  color="textSecondary"
                  className={classes.footerLink}
                  href="https://www.vidyard.com/about-vidyard/"
                  target="_blank"
                >
                  About Vidyard
                </Link>
              </li>
              <li>
                <Link
                  variant="subtitle1"
                  color="textSecondary"
                  className={classes.footerLink}
                  href="https://www.vidyard.com/free-screen-record/"
                  target="_blank"
                >
                  Free Screen Recorder
                </Link>
              </li>
              <li>
                <Link
                  variant="subtitle1"
                  color="textSecondary"
                  className={classes.footerLink}
                  href="https://www.vidyard.com/video-creation/"
                  target="_blank"
                >
                  Video Creation
                </Link>
              </li>
              <li>
                <Link
                  variant="subtitle1"
                  color="textSecondary"
                  className={classes.footerLink}
                  href="https://www.vidyard.com/video-hosting/"
                  target="_blank"
                >
                  Video Hosting
                </Link>
              </li>
              <li>
                <Link
                  variant="subtitle1"
                  color="textSecondary"
                  className={classes.footerLink}
                  href="https://www.vidyard.com/video-analytics/"
                  target="_blank"
                >
                  Video Analytics
                </Link>
              </li>
              <li>
                <Link
                  variant="subtitle1"
                  color="textSecondary"
                  className={classes.footerLink}
                  href="https://www.vidyard.com/video-marketing/personalized-video/"
                  target="_blank"
                >
                  Video Personalization
                </Link>
              </li>
              <li>
                <Link
                  variant="subtitle1"
                  color="textSecondary"
                  className={classes.footerLink}
                  href="https://www.vidyard.com/product-features/"
                  target="_blank"
                >
                  See All Features
                </Link>
              </li>
              <li>
                <Link
                  variant="subtitle1"
                  color="textSecondary"
                  className={classes.footerLink}
                  href="https://www.vidyard.com/pricing/"
                  target="_blank"
                >
                  Pricing
                </Link>
              </li>
            </ul>
          </Grid>
          <Grid item xs={12} sm={12} md={2} className={classes.footerColumn}>
            <Typography
              variant="h6"
              color="textPrimary"
              className={classes.footerHeader}
              gutterBottom
            >
              Solutions
            </Typography>
            <ul>
              <li>
                <Link
                  variant="subtitle1"
                  color="textSecondary"
                  className={classes.footerLink}
                  href="https://www.vidyard.com/video-marketing/"
                  target="_blank"
                >
                  Marketing
                </Link>
              </li>
              <li>
                <Link
                  variant="subtitle1"
                  color="textSecondary"
                  className={classes.footerLink}
                  href="https://www.vidyard.com/video-corporate-communications/"
                  target="_blank"
                >
                  Corporate Comms
                </Link>
              </li>
              <li>
                <Link
                  variant="subtitle1"
                  color="textSecondary"
                  className={classes.footerLink}
                  href="https://www.vidyard.com/video-sales/"
                  target="_blank"
                >
                  Sales
                </Link>
              </li>
              <li>
                <Link
                  variant="subtitle1"
                  color="textSecondary"
                  className={classes.footerLink}
                  href="https://www.vidyard.com/enterprise-video-platform/"
                  target="_blank"
                >
                  Enterprise
                </Link>
              </li>
              <li>
                <Link
                  variant="subtitle1"
                  color="textSecondary"
                  className={classes.footerLink}
                  href="https://www.vidyard.com/industries/"
                  target="_blank"
                >
                  See All Industries
                </Link>
              </li>
            </ul>
          </Grid>
          <Grid item xs={12} sm={12} md={2} className={classes.footerColumn}>
            <Typography
              variant="h6"
              color="textPrimary"
              className={classes.footerHeader}
              gutterBottom
            >
              Learn
            </Typography>
            <ul>
              <li>
                <Link
                  variant="subtitle1"
                  color="textSecondary"
                  className={classes.footerLink}
                  href="https://www.vidyard.com/integrations/"
                  target="_blank"
                >
                  Integrations
                </Link>
              </li>
              <li>
                <Link
                  variant="subtitle1"
                  color="textSecondary"
                  className={classes.footerLink}
                  href="https://knowledge.vidyard.com/hc/en-us"
                  target="_blank"
                >
                  Knowledge Base
                </Link>
              </li>
              <li>
                <Link
                  variant="subtitle1"
                  color="textSecondary"
                  className={classes.footerLink}
                  href="https://knowledge.vidyard.com/hc/en-us/community/topics"
                  target="_blank"
                >
                  Community
                </Link>
              </li>
              <li>
                <Link
                  variant="subtitle1"
                  color="textSecondary"
                  className={classes.footerLink}
                  href="https://www.vidyard.com/partners-directory/"
                  target="_blank"
                >
                  Partners Directory
                </Link>
              </li>
              <li>
                <Link
                  variant="subtitle1"
                  color="textSecondary"
                  className={classes.footerLink}
                  href="https://www.vidyard.com/blog/"
                  target="_blank"
                >
                  Blog
                </Link>
              </li>
              <li>
                <Link
                  variant="subtitle1"
                  color="textSecondary"
                  className={classes.footerLink}
                  href="https://www.vidyard.com/resources/"
                  target="_blank"
                >
                  Content Library
                </Link>
              </li>
              <li>
                <Link
                  variant="subtitle1"
                  color="textSecondary"
                  className={classes.footerLink}
                  href="https://www.vidyard.com/video-inspiration/"
                  target="_blank"
                >
                  Video Inspiration
                </Link>
              </li>
              <li>
                <Link
                  variant="subtitle1"
                  color="textSecondary"
                  className={classes.footerLink}
                  href="https://www.vidyard.com/events/"
                  target="_blank"
                >
                  Webinars and Events
                </Link>
              </li>
              <li>
                <Link
                  variant="subtitle1"
                  color="textSecondary"
                  className={classes.footerLink}
                  href="https://www.vidyard.com/customers/"
                  target="_blank"
                >
                  Case Studies
                </Link>
              </li>
            </ul>
          </Grid>
          <Grid item xs={12} sm={12} md={2} className={classes.footerColumn}>
            <Typography
              variant="h6"
              color="textPrimary"
              className={classes.footerHeader}
              gutterBottom
            >
              Resources
            </Typography>
            <ul>
              <li>
                <Link
                  variant="subtitle1"
                  color="textSecondary"
                  className={classes.footerLink}
                  href="https://www.vidyard.com/services/"
                  target="_blank"
                >
                  Professional Services
                </Link>
              </li>
              <li>
                <Link
                  variant="subtitle1"
                  color="textSecondary"
                  className={classes.footerLink}
                  href="https://www.vidyard.com/partners/"
                  target="_blank"
                >
                  Partners
                </Link>
              </li>
              <li>
                <Link
                  variant="subtitle1"
                  color="textSecondary"
                  className={classes.footerLink}
                  href="https://www.vidyard.com/developers/"
                  target="_blank"
                >
                  Developers
                </Link>
              </li>
              <li>
                <Link
                  variant="subtitle1"
                  color="textSecondary"
                  className={classes.footerLink}
                  href="https://www.vidyard.com/customer-support/"
                  target="_blank"
                >
                  Support
                </Link>
              </li>
              <li>
                <Link
                  variant="subtitle1"
                  color="textSecondary"
                  className={classes.footerLink}
                  href="https://knowledge.vidyard.com/hc/en-us/community/topics/360001538493-What-s-New"
                  target="_blank"
                >
                  Product Updates
                </Link>
              </li>
              <li>
                <Link
                  variant="subtitle1"
                  color="textSecondary"
                  className={classes.footerLink}
                  href="https://www.vidyard.com/mic-test/"
                  target="_blank"
                >
                  Mic Test
                </Link>
              </li>
              <li>
                <Link
                  variant="subtitle1"
                  color="textSecondary"
                  className={classes.footerLink}
                  href="https://www.vidyard.com/cam-test/"
                  target="_blank"
                >
                  Cam Test
                </Link>
              </li>
            </ul>
          </Grid>
        </Grid>
        <Divider style={{ marginTop: "50px", marginBottom: "20px" }} />
        <Grid container spacing={4} justify="space-evenly">
          <Grid item xs={12} sm={12} md={3} className={classes.footerColumn}>
            <Link
              className={`${classes.footerLink} ${classes.socialLink}`}
              href="https://www.twitter.com/vidyard"
              target="_blank"
            >
              <TwitterIcon />
            </Link>
            <Link
              className={`${classes.footerLink} ${classes.socialLink}`}
              href="https://www.facebook.com/teamvidyard"
              target="_blank"
            >
              <FacebookIcon />
            </Link>
            <Link
              className={`${classes.footerLink} ${classes.socialLink}`}
              href="https://www.instagram.com/teamvidyard"
              target="_blank"
            >
              <InstagramIcon />
            </Link>
            <Link
              className={`${classes.footerLink} ${classes.socialLink}`}
              href="https://www.youtube.com/user/vidyard"
              target="_blank"
            >
              <YouTubeIcon />
            </Link>
            <Link
              className={`${classes.footerLink} ${classes.socialLink}`}
              href="https://www.linkedin.com/company/2086508"
              target="_blank"
            >
              <LinkedInIcon />
            </Link>
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={5}
            className={classes.footerColumn}
            style={{ textAlign: "center" }}
          >
            <Link
              className={classes.footerLink}
              style={{ padding: "0 8px" }}
              href="https://www.vidyard.com/privacy/"
              target="_blank"
            >
              Privacy Policy
            </Link>
            <Link
              className={`${classes.footerLink} ${classes.privacyBorder}`}
              href="https://www.vidyard.com/legal/"
              target="_blank"
            >
              Legal Stuff
            </Link>
            <Link
              className={`${classes.footerLink} ${classes.privacyBorder}`}
              href="https://www.vidyard.com/accessibility/"
              target="_blank"
            >
              Accessibility
            </Link>
            <Link
              className={`${classes.footerLink} ${classes.privacyBorder}`}
              href="https://www.vidyard.com/sitemap_index.xml"
              target="_blank"
            >
              Sitemap
            </Link>
          </Grid>
          <Grid item xs={12} sm={12} md={4} className={classes.footerColumn}>
            <Copyright />
          </Grid>
        </Grid>
      </Container>
    </div>
  );
}

export default Footer;
